var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSettingsBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "streamline:interface-setting-pie-chart-cog-setting-graph-cog",
    clipPath: "url(#clip0_496_15136)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.483 1.92871L4.85157 0.977282C4.91373 0.816194 5.02309 0.677634 5.16533 0.57975C5.30756 0.481866 5.47605 0.429221 5.64871 0.428711H6.35157C6.52423 0.429221 6.69272 0.481866 6.83496 0.57975C6.97719 0.677634 7.08655 0.816194 7.14871 0.977282L7.51728 1.92871L8.76871 2.64871L9.78014 2.49443C9.94855 2.47157 10.12 2.49929 10.2726 2.57407C10.4252 2.64886 10.5521 2.76733 10.6373 2.91443L10.9801 3.51442C11.068 3.66387 11.1085 3.83644 11.0962 4.00936C11.084 4.18228 11.0196 4.34742 10.9116 4.483L10.2859 5.28014V6.72014L10.9287 7.51728C11.0367 7.65286 11.1011 7.818 11.1134 7.99092C11.1256 8.16384 11.0851 8.33641 10.9973 8.48585L10.6544 9.08585C10.5693 9.23295 10.4423 9.35142 10.2897 9.4262C10.1371 9.50099 9.9657 9.52871 9.79728 9.50585L8.78585 9.35157L7.53443 10.0716L7.16585 11.023C7.1037 11.1841 6.99434 11.3226 6.8521 11.4205C6.70986 11.5184 6.54138 11.5711 6.36871 11.5716H5.64871C5.47605 11.5711 5.30756 11.5184 5.16533 11.4205C5.02309 11.3226 4.91373 11.1841 4.85157 11.023L4.483 10.0716L3.23157 9.35157L2.22014 9.50585C2.05173 9.52871 1.88032 9.50099 1.7277 9.4262C1.57508 9.35142 1.44813 9.23295 1.363 9.08585L1.02014 8.48585C0.932285 8.33641 0.891807 8.16384 0.904049 7.99092C0.916291 7.818 0.980678 7.65286 1.08871 7.51728L1.71443 6.72014V5.28014L1.07157 4.483C0.963535 4.34742 0.899148 4.18228 0.886906 4.00936C0.874664 3.83644 0.915142 3.66387 1.003 3.51442L1.34585 2.91443C1.43099 2.76733 1.55793 2.64886 1.71055 2.57407C1.86317 2.49929 2.03458 2.47157 2.203 2.49443L3.21443 2.64871L4.483 1.92871Z",
    stroke: "#29406C",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.00014 8.57157C7.4203 8.57157 8.57157 7.4203 8.57157 6.00014C8.57157 4.57998 7.4203 3.42871 6.00014 3.42871C4.57998 3.42871 3.42871 4.57998 3.42871 6.00014C3.42871 7.4203 4.57998 8.57157 6.00014 8.57157Z",
    stroke: "#29406C",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.00025 3.42871V6.00014M6.00025 6.00014H8.57168M6.00025 6.00014L4.18311 7.81728",
    stroke: "#29406C",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_496_15136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsBlue);
export default __webpack_public_path__ + "static/media/settings-blue.59f2517960463176adee961dee7f88ef.svg";
export { ForwardRef as ReactComponent };